import script from "./CommonForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonForm.vue?vue&type=script&lang=ts&setup=true"

import "./CommonForm.vue?vue&type=style&index=0&id=19b2271e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b2271e"]])

export default __exports__